import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import momentTz from 'moment-timezone';
import lang from '../../lang';
import { createFetch } from '../../utils';
import { registerAccessToken, updateUserInfo } from '../Login/actions';
import FilterWithAuth from '../../components/FilterWithAuth';
import { getObjectDescription } from '../../containers/actions';
const { URL_PREFIX, API_SERVER_URL } = window;


class Me extends React.Component {
    constructor() {
        super();
        this.state = {
            editMode: false,
            form: {},
            errorMessage: [],
            loading: false,
            _tempImage: null,
        };
        this.changeForm = this.changeForm.bind(this);
        this.changeImage = this.changeImage.bind(this);
    }

    componentWillMount() {
        setTimeout(() => {
            const { info: userInfo } = this.props.user;
            this.setState({
                form: {
                    firstName: userInfo.firstName,
                    lastName: userInfo.lastName,
                    avatar: userInfo.avatar ? userInfo.avatar : null,
                    username: userInfo.username,
                    email: userInfo.email,
                    phoneNumber: userInfo.phoneNumber,
                    gender: userInfo.gender,
                    timezone: userInfo.timezone,
                },
            });
        }, 5000);
    }

    async save() {
        if (this.state.loading) return;
        const { user } = this.props;
        this.setState({ loading: true });
        try {
            const result = await createFetch({
                path: 'users/me',
                method: 'PATCH',
                accessToken: user.accessToken,
                body: this.state.form,
            });
            if (result.status === 200) {
                Swal.fire({
                    text: result.message,
                    title: lang.profile.successProfileSaved,
                    type: 'success',
                });
                this.props.registerAccessToken(result.token.token, result.token.expiredAt);
                this.props.updateUserInfo(result.userJson);
                this.setState({ form: { ...this.state.form, avatar: result.userJson.avatar } });
                this.setState({ loading: false, errorMessage: {}, editMode: false });
                return;
            }
            if (result.status === 400) {
                const errorMessage = {};
                result.validation.forEach((o) => {
                    errorMessage[o.param] = lang.serverMessage[o.msg] || o.msg;
                });
                this.setState({
                    errorMessage,
                    loading: false,
                });
                return;
            }
            const error = new Error();
            error.message = lang.serverMessage[result.message] || result.message;
            throw error;
        } catch (error) {
            this.setState({ loading: false });
            Swal.fire({
                text: error.message,
                title: lang.titleError,
                type: 'warning',
            });
        }
    }


    changeForm(e) {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value,
            },
        });
    }

    changeImage(e) {
        e.preventDefault();
        const image = e.target.files[0];
        this.setState({
            _tempImage: URL.createObjectURL(image),
        });
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onloadend = () => {
            const b64 = reader.result.replace(/^data:.+;base64,/, '');
            this.setState({
                form: {
                    ...this.state.form,
                    avatar: b64,
                },
            });
        };
    }

    render() {
        const { info: userInfo, profile } = this.props.user;
        const {
            editMode, form, loading, errorMessage, _tempImage,
        } = this.state;
        if (userInfo === undefined || userInfo === null) return null;
        let defaultAvatar = require('../../static/img/avatar-.png');
        if (userInfo.gender === 'F') defaultAvatar = require('../../static/img/avatar-F.png');
        else if (userInfo.gender === 'M') defaultAvatar = require('../../static/img/avatar-M.png');
        return (
            <ReactModal
                className="meView"
                overlayClassName="overlay-me"
                id="meView"
                isOpen={this.props.visible}
                closeTimeoutMS={2000}
                ariaHideApp={false}
                onRequestClose={() => this.props.toggleModal()}
            >
                <Link
                    to="#"
                    onClick={(e) => {
                        e.preventDefault();
                        this.props.toggleModal();
                    }}
                    className="btn-close"
                >
                    <i className="fa fa-times" />
                </Link>
                <div className="avatar">
                    {editMode ? (
                        <div className="container-avatar">
                            {_tempImage !== null ? (
                                <img src={_tempImage} alt="avatar" />
                            ) : (
                                <img
                                    src={userInfo.avatar ? `${API_SERVER_URL}${userInfo.avatar}` : defaultAvatar}
                                    alt="avatar"
                                />
                            )}
                            <label className="btn-upload">
                                <input name="avatar" type="file" style={{ display: 'none' }} onChange={this.changeImage} />
                                Upload Avatar {' '}
                                <i className="fa fa-upload" />
                            </label>
                        </div>
                    ) : (
                        <img
                            src={userInfo.avatar ? `${API_SERVER_URL}${userInfo.avatar}` : defaultAvatar}
                            alt="avatar"
                        />
                    )}
                </div>
                <p className="name">
                    {userInfo.firstName} {userInfo.lastName}
                </p>
                <p className="role">
                    {userInfo.role}
                </p>
                <div style={{ height: 20 }} />
                <div className="info">
                    <p className="label">First Name</p>
                    {editMode ? (
                        <div className="value-input">
                            <input type="text" className="form-control" value={form.firstName} name="firstName" onChange={this.changeForm} />
                        </div>)
                        : <p className="value">: &nbsp;{userInfo.firstName}</p>}
                </div>
                {errorMessage.firstName ? <p className="error-message">{errorMessage.firstName }</p> : null}
                <div className="info">
                    <p className="label">Last Name</p>
                    {editMode ? (
                        <div className="value-input">
                            <input type="text" className="form-control" value={form.lastName} name="lastName" onChange={this.changeForm} />
                        </div>)
                        : <p className="value">: &nbsp;{userInfo.lastName}</p>}
                </div>
                {errorMessage.lastname ? <p className="error-message">{errorMessage.lastname}</p> : null}
                <div className="info">
                    <p className="label">Username</p>
                    {editMode ? (
                        <div className="value-input">
                            <input type="text" className="form-control" value={form.username} name="username" onChange={this.changeForm} />
                        </div>)
                        : <p className="value">: &nbsp;{userInfo.username}</p>}
                </div>
                {errorMessage.username ? <p className="error-message">{errorMessage.username}</p> : null}
                <div className="info">
                    <p className="label">Email</p>
                    {editMode ? (
                        <div className="value-input">
                            <input type="text" className="form-control" value={form.email} name="email" onChange={this.changeForm} />
                        </div>)
                        : <p className="value">: &nbsp;{userInfo.email}</p>}
                </div>
                {errorMessage.email ? <p className="error-message">{errorMessage.email}</p> : null}
                <div className="info">
                    <p className="label">Phone Number</p>
                    {editMode ? (
                        <div className="value-input">
                            <input type="text" className="form-control" value={form.phoneNumber} name="phoneNumber" onChange={this.changeForm} />
                        </div>)
                        : <p className="value">: &nbsp;{userInfo.phoneNumber}</p>}
                </div>
                {errorMessage.phoneNumber ? <p className="error-message">{errorMessage.phoneNumber}</p> : null}
                <div className="info">
                    <p className="label">Gender</p>
                    {editMode ? (
                        <div className="value-input">
                            <select className="form-control" value={form.gender} name="gender" onChange={this.changeForm}>
                                <option value="" />
                                <option value="M">Male</option>
                                <option value="F">Female</option>
                            </select>
                        </div>)
                        : <p className="value">: &nbsp;{userInfo.gender}</p>}
                </div>
                <div className="info">
                    <p className="label">Timezone</p>
                    {editMode ? (
                        <div className="value-input">
                            <select className="form-control" value={form.timezone} name="timezone" onChange={this.changeForm}>
                                <option value="" />
                                {momentTz.tz.names().map(o => <option value={o}>{o}</option>)}
                            </select>
                        </div>)
                        : <p className="value">: &nbsp;{userInfo.timezone}</p>}
                </div>
                {errorMessage.gender ? <p className="error-message">{errorMessage.gender}</p> : null}
                <div className="info">
                    <p className="label">Profile</p>
                    <p className="value">: &nbsp;{profile.name}</p>
                </div>
                <div className="info button-section" style={{ width: editMode ? '100%' : '80%' }}>
                    
                    { editMode ? (
                        [
                            <button className="btn btn-primary" onClick={() => this.save()} key="saveBtn" disabled={loading}>
                                {lang.common.save}
                            </button>,
                            <button className="btn btn-warning" onClick={() => this.setState({ editMode: false, errorMessage: {}, _tempImage: null })} key="cancelBtn" disabled={loading}>
                                {lang.common.cancel}
                            </button>,
                        ]
                    ) : (
                        <button className="btn btn-alternate" onClick={() => this.setState({ editMode: true })}>
                            {lang.common.edit} Profile
                        </button>
                    )}
                    <button
                        className="btn btn-default"
                        disabled={loading}
                        onClick={() => {
                            this.props.toggleModal();
                            this.props.history.replace(`${URL_PREFIX}/app/reset-password`);
                        }}
                    >
                        {lang.common.edit} password
                    </button>
                </div>
                <FilterWithAuth
                    authRequired={['menu:Apps:refreshCache']}
                >
                    <button
                        className="btn btn-danger btn-lg"
                        disabled={loading}
                        onClick={async () => {
                            this.setState({ loading: true });
                            await this.props.getObjectDescription(true);
                            Swal.fire({
                                title: 'Salesforce object refreshed',
                                text: 'Salesforce object description has been refreshed please refresh the page to see changes',
                                type: 'info',
                            });
                            this.setState({ loading: false });
                        }}
                    >
                        <i className="fa fa-sync" /> {loading ? 'Refreshing...' : 'Refresh SfObject Cache'}
                    </button>
                </FilterWithAuth>
            </ReactModal>
        );
    }
}

Me.propTypes = {
    visible: propTypes.bool.isRequired,
    toggleModal: propTypes.func.isRequired,
    user: propTypes.object.isRequired,
    registerAccessToken: propTypes.func.isRequired,
    history: propTypes.object.isRequired,
    getObjectDescription: propTypes.func.isRequired,
    updateUserInfo: propTypes.func.isRequired,
};


const mapDispatchToProps = dispatch => (
    bindActionCreators({
        registerAccessToken,
        getObjectDescription,
        updateUserInfo,
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
});


export default connect(mapStateToProps, mapDispatchToProps)(Me);
